import { render } from "./MenuButton.vue?vue&type=template&id=7e7641bc"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"
script.render = render

export default script